import { css } from 'linaria';
import { Variables } from '../index';
import { ContainerProps } from './';

export const root = css`
    padding: ${Variables.css.spacing24};
`;

export const rounded = css`
    border-radius: 4px;
`;

export const sizes: Record<ContainerProps['size'], string> = {
    none: css`
        padding: 0;
    `,
    'extra-small': css`
        padding: ${Variables.css.spacing8};
    `,
    small: css`
        padding: ${Variables.css.spacing16};
    `,
    medium: css`
        padding: ${Variables.css.spacing24};
    `,
    large: css`
        padding: ${Variables.css.spacing32};
    `,
    'extra-large': css`
        padding: ${Variables.css.spacing48};
    `,
};
